import React from 'react'

import { Breadcrumb } from '@portal/kit/pkg/components'

const steps = [
  { name: 'authentication' },
  { name: 'payment' },
  { name: 'confirmation' }
]

export default function OffersBreadcrumb({ step }) {
  return <Breadcrumb
    steps={steps}
    step={step}
    i18nScope="portal.offers.breadcrumb"
    showMobileName />
}
